import React, { useState, useRef, useEffect } from "react";

export default function Dropdown({ title, list }) {
    const container = useRef();
    const [dropdownState, setDropdownState] = useState(false);
    const handleClickOutside = (e) => {
        if (container.current && !container.current.contains(e.target)) {
            setDropdownState(false);
        }
    };
    const handleDropdownClick = () =>
        setDropdownState(!dropdownState);

    const GenerateDropDownItems = () => {
        return (
            <ul className="dropdown-list">
                {list.map((item, index) => {
                    return (
                        <li key={index}>
                            {item.component}
                        </li>
                    )
                })}
            </ul>
        )
    }
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return (
        <div className="dropdown-container" ref={container}>
            <div className={!dropdownState ? "dropdown closed" : "dropdown open"}>
                <div onClick={handleDropdownClick} className="dropdown-text">{title}</div>
                {GenerateDropDownItems()}
            </div>
        </div>
    );
}